<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M14.2071 3.79289C14.5976 4.18342 14.5976 4.81658 14.2071 5.20711L6.20711 13.2071C6.01957 13.3946 5.76522 13.5 5.5 13.5C5.23478 13.5 4.98043 13.3946 4.79289 13.2071L1.79289 10.2071C1.40237 9.81658 1.40237 9.18342 1.79289 8.79289C2.18342 8.40237 2.81658 8.40237 3.20711 8.79289L5.5 11.0858L12.7929 3.79289C13.1834 3.40237 13.8166 3.40237 14.2071 3.79289Z"
		fill="currentColor"
	/>
</svg>
